import { render, staticRenderFns } from "./UserAvatar.vue?vue&type=template&id=42ad3b50&scoped=true&"
import script from "./UserAvatar.vue?vue&type=script&lang=ts&"
export * from "./UserAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./UserAvatar.vue?vue&type=style&index=0&id=42ad3b50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ad3b50",
  null
  
)

export default component.exports